/**
 * Datos del gráfico de evolución (US4)
 */

import type { TrendGranularity, TrendMetric, TrendPoint } from '@/types/dashboard';

export const METRIC_OPTIONS: { value: TrendMetric; label: string }[] = [
  { value: 'memories', label: 'Recuerdos' },
  { value: 'video_views', label: 'Visualizaciones' },
  { value: 'review_clicks', label: 'Clics en reseña' },
  { value: 'new_clients', label: 'Clientes nuevos' },
  { value: 'returning_clients', label: 'Clientes que vuelven' },
];

export interface Bar {
  key: string;
  label: string;
  fullLabel: string;
  value: number;
  previousYear: number | null;
  partial: boolean;
}

function monthDate(period: string): Date {
  const [year, month] = period.split('-').map(Number);
  return new Date(year, month - 1, 1);
}

function monthLabel(period: string, style: 'short' | 'long'): string {
  const date = monthDate(period);
  const month = date.toLocaleDateString('es-ES', { month: style }).replace('.', '');
  return style === 'short' ? `${month} ${String(date.getFullYear()).slice(2)}` : `${month} de ${date.getFullYear()}`;
}

export function buildBars(points: TrendPoint[], granularity: TrendGranularity, metric: TrendMetric): Bar[] {
  if (granularity === 'year') {
    return points.map((p) => ({
      key: p.period,
      label: p.period,
      fullLabel: p.partial ? `${p.period} (en curso)` : p.period,
      value: p[metric],
      previousYear: null,
      partial: p.partial,
    }));
  }

  const visible = points.slice(-12);
  const offset = points.length - visible.length;
  return visible.map((p, i) => {
    const before = offset + i - 12 >= 0 ? points[offset + i - 12] : null;
    return {
      key: p.period,
      label: monthLabel(p.period, 'short'),
      fullLabel: `${monthLabel(p.period, 'long')}${p.partial ? ' (en curso)' : ''}`,
      value: p[metric],
      previousYear: before ? before[metric] : null,
      partial: p.partial,
    };
  });
}
